export default "__VITE_ASSET__1f5b74eb__"